import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDeletedFilter'
})
export class IsDeletedFilterPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param value
   */
  transform(items: any[], value: any): any {
    // value === falseの場合　isDeleted == false または　undefined のものを返す
    if(!value) {
      return items.filter(x =>
        typeof x.isDeleted === 'undefined' || x.isDeleted === value);
    }
    // value === trueの場合　isDeleted == true　のものを返す
    return items.filter(x =>
      x.isDeleted === value);
  }
}
